var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineT(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56.6934,
    height: 56.6934,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#0d3968",
    id: "svg_1",
    d: "m44.9246,24.5134c-0.1648,-7.0623 -5.9371,-12.7376 -13.039,-12.7376c-4.9299,0 -9.2199,2.735 -11.4387,6.7698c-1.0023,-0.576 -2.1633,-0.9071 -3.4024,-0.9071c-3.6061,0 -6.5584,2.7912 -6.8195,6.3306c-3.5574,1.4606 -6.0636,4.9576 -6.0636,9.0415c0,5.3968 4.3749,9.7718 9.7718,9.7718l29.396,0c5.0836,0 9.2047,-4.1211 9.2047,-9.2047c0,-4.5394 -3.2866,-8.3084 -7.6093,-9.0643z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineT);
export default __webpack_public_path__ + "static/media/onlineT.73afa3e3cd1e54eb5b7135482ad644bf.svg";
export { ForwardRef as ReactComponent };